module.exports = "/virtual-football-league/img/amblems/right/logos/WestHamUtd.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/WestHamUtd.png
// module id = 2236
// module chunks = 4